<a #topOfPage id="topOfPage"></a>
<div class="page-content" page-content >

  <prism-ui-heading
    slot="policy-number-heading"
    key-id="policy-number-heading"
    font-size="lg"
    font-weight="regular"
    is-uppercase="false"
    variant="default"
    >
    {{pageTitle}}
  </prism-ui-heading>

  @if(this.ceoiPolicyFlag){
    <ng-container>
      <div class="topPadding bottomPadding">
        <prism-ui-container
          is-compact="false"
          key-id="notification"
          has-shadow="false"
          variant="neutral"
          has-no-border-radius="false"
          >
          <prism-ui-copy
            key-id="notification"
            >
            <h2>{{ceoiPolicyFlagContent.title}}</h2>
            <p>{{ceoiPolicyFlagContentBodyTrim}}</p>
          </prism-ui-copy>
        </prism-ui-container>
      </div>
    </ng-container>
  } @else{
    @if (!this.evidenceRequired) {
      <div class="topPadding bottomPadding">
        <prism-ui-container
          is-compact="false"
          key-id="notification"
          has-shadow="false"
          variant="neutral"
          has-no-border-radius="false"
          >
          <prism-ui-copy
            key-id="notification"
            >
            <h2>{{evidenceContent.title}}</h2>
            <p>{{messageText}}</p>
          </prism-ui-copy>
        </prism-ui-container>
      </div>
    }
  }
  <form id="policyForm" [formGroup]="policyForm" #formDirective="ngForm" (ngSubmit)="onSubmit()">
    <prism-ui-container
      is-compact="false"
      key-id="policy-container"
      has-shadow="false"
      variant="default"
      has-no-border-radius="false"
      >
      @if (!isCustomUrl) {
        <div class="row">
          <prism-ui-form-field
            key-id="policyPolicyNumber"
            [isValid]="formControlUtilitiesService.isControlValid(policyForm, 'policyNumber')"
            >
            <span slot="label">
              <div class="alignTooltips">
                {{policyElement?.label}}
                <div class="toolTipLeftPadding">
                  <prism-ui-icon-button
                    expanded="false"
                    has-tooltip="true"
                    icon-name="circle-info"
                    is-inactive="false"
                    is-waiting="false"
                    key-id="eeoi-tooltip-wizard-policy-number"
                    label="{{policyToolTipDescription}}"
                    size="small"
                    [tooltipPosition]="policyTooltipPosition"
                    type="button"
                    variant="tertiary"
                    >
                    <div class="policyTooltipWidth policyTooltipPadding">
                      <prism-ui-copy key-id="policyTooltip">{{policyToolTipDescription}}</prism-ui-copy>
                    </div>
                  </prism-ui-icon-button>
                </div>
              </div>
            </span>
            <span slot="helper-text">{{ policyElement?.hint }}</span>
            <span slot="error">{{ policyElement?.error }}</span>
            <prism-ui-input-text
              slot="input"
              ngDefaultControl
              [formGroup]="policyForm"
              formControlName="policyNumber"
              name="policyNumber"
              id="policyNumber"
              key-id="policyNumber"
              placeholder="{{policyElement?.placeholder}}"
              max-length="6"
              min-length="0"
              autocomplete="off"
              [isValid]="formControlUtilitiesService.isControlValid(policyForm, 'policyNumber')"
              (keyup)="onKeyUpPolicyNumber()"
              (input)="onPolicyNumberInput($event)"
            ></prism-ui-input-text>
          </prism-ui-form-field>
        </div>
      }
      
@if (formSubmittedAndSpinnerStart) {
    <div class="page-loader">
      <prism-ui-loader
        has-logo="false"
        is-reverse="false"
        key-id="page-loader"
        size="md"
        >
      </prism-ui-loader>
      <prism-ui-copy
        font-size="md"
        font-style="normal"
        font-weight="regular"
        key-id="page-loader-label"
        line-height="medium"
        text-decoration="none"
        variant="default"
        >
        <span>{{pageLoaderElement?.label}}</span>
      </prism-ui-copy>
    </div>
  }

      @if (isCustomUrl) {
        <div>
          <div class="row">
            <div class="col-sm-12">
              <prism-ui-copy>
                <span [innerHTML]="instructions?.body"></span>
              </prism-ui-copy>
            </div>
          </div>
        </div>
      }

      @if (groupName.value) {
        <div>
          @if (!isCustomUrl) {
            <div class="row">&nbsp;</div>
          }
          <div class="row">
            <prism-ui-form-field
              key-id="groupName"
              >
              <span slot="label">
                <div class="alignTooltips">
                  {{grpNameElement?.label}}
                  @if (displayHelpText) {
                    <div class="toolTipLeftPadding">
                      <prism-ui-icon-button
                        expanded="false"
                        has-tooltip="true"
                        icon-name="circle-info"
                        is-inactive="false"
                        is-waiting="false"
                        key-id="policyholder-generic-form"
                        label="{{grpNameToolTipDescription}}"
                        size="small"
                        [tooltipPosition]="groupTooltipPosition"
                        type="button"
                        variant="tertiary"
                        >
                        <div class="groupTooltipWidth policyTooltipPadding">
                          <prism-ui-copy key-id="groupNameTooltip">{{grpNameToolTipDescription}}</prism-ui-copy>
                        </div>
                      </prism-ui-icon-button>
                    </div>
                  }
                </div>
              </span>
              <span slot="helper-text">{{ grpNameElement?.hint }}</span>
              <prism-ui-input-text
                slot="input"
                ngDefaultControl
                [formGroup]="groupName"
                formControlName="groupName"
                name="groupName"
                id="groupName"
                key-id="grpNameElement"
                autocomplete="off"
                is-readonly="true"
                [defaultValue]="policyForm.get('groupName')?.value"
              ></prism-ui-input-text>
            </prism-ui-form-field>
          </div>
          <br>
            <div class="row">
              @if (this.evidenceRequired && !this.ceoiPolicyFlag && agencyLocations?.length > 1) {
                <div class="autoCompleteOnTop">
                  <prism-ui-form-field
                    key-id="location"
                    [isValid]="formControlUtilitiesService.isControlValid(policyForm, 'agencyLocation')"
                    >
                    <span slot="label">{{ locationElement?.label }}</span>
                    <span slot="helper-text">{{ locationElement?.hint}}</span>
                    @if (policyForm.get('agencyLocation').hasError('required') && policyForm.get('agencyLocation').touched) {
                      <span slot="error">{{locationElement?.error}}</span>
                    }
                    @if (policyForm.get('agencyLocation').hasError('inValidAgencyLocation') && policyForm.get('agencyLocation').touched) {
                      <span slot="error">Please Enter valid Division/Location</span>
                    }
                  </prism-ui-form-field>
                  <prism-ui-input-text
                    autocomplete="off"
                    ngDefaultControl
                    aria-label="Number"
                    list="agencyLocationList"
                    max-length="100"
                    min-length="0"
                    [formGroup]="policyForm"
                    formControlName="agencyLocation"
                    name="agencyLocation"
                    id="agencyLocation"
                    key-id="location"
                    placeholder="{{locationElement.placeholder}}"
                    (keyup)="onKeyUp()"
                    [(ngModel)]="selectedLocation"
                    [attr.default-value]="selectedLocation"
                    (click)="locationInputClickEvent()"
                    [isValid]="formControlUtilitiesService.isControlValid(policyForm, 'agencyLocation')"
                    #myAgencyLocation
                  ></prism-ui-input-text>
                  <div [style.width.px]='myAgencyLocation.offsetWidth' [style.display]='display()'>
                    <prism-ui-options key-id="filteredAgencyLocations"
                      [optionsCount]="filteredAgencyLocations.length">
                      @for(agencyLocation of filteredAgencyLocations() ; track agencyLocation; let index = $index){
                        <prism-ui-option
                          [slot]="index + 1"
                          [keyId]="agencyLocation?.id"
                          [label]="agencyLocation?.name"
                          (optionClicked)="onSelectionChange(agencyLocation?.name)"
                        ></prism-ui-option>
                      }
                    </prism-ui-options>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </prism-ui-container>

      @if (evidenceRequired && !ceoiPolicyFlag) {
        <div class="continueCancelButtonPadding">
          <app-continue-cancel (cancelEmitter)="onCancel()"></app-continue-cancel>
        </div>
      }

      <div class="topPadding">
        @if (!evidenceRequired || ceoiPolicyFlag) {
          <prism-ui-button class="center"
            button-width="content"
            key-id="clear-button"
            size="md"
            variant="primary"
            type="button"
            is-icon-right-aligned="false"
            is-waiting="false"
            (click)="resetPolicyNumber()"
          >Try a Different Policy Number</prism-ui-button>
        }
      </div>
    </form>
  </div>

  <prism-ui-modal key-id="cancel-modal" has-dark-overlay="true">
    <prism-ui-heading
      slot="modal-header"
      key-id="cancel-modal"
      font-size="sm"
      font-weight="strong"
      >{{modalContentHeading}}</prism-ui-heading
      >
      <prism-ui-copy
        slot="modal-body"
        key-id="cancel-modal"
        >
        {{modalContentBody}}
      </prism-ui-copy>
      <div slot="modal-footer">
        <div class="modalButtonStyling">
          <prism-ui-button class="leftPadding"
            button-width="full"
            key-id="cancel-button"
            size="md"
            variant="secondary"
            type="button"
            is-icon-right-aligned="false"
            (click)="onCancelModal('prism-ui-modal-cancel-modal')"
          >Cancel</prism-ui-button>
          <prism-ui-button class="leftPaddingSmall"
            button-width="full"
            key-id="continue-button"
            size="md"
            variant="primary"
            type="button"
            is-icon-right-aligned="false"
            (click)="leaveAnyway()"
          >Leave Anyway</prism-ui-button>
        </div>
      </div>
    </prism-ui-modal>

    <prism-ui-modal key-id="redirect-modal" has-dark-overlay="true">
      <prism-ui-heading
        slot="modal-header"
        key-id="redirect-modal"
        font-size="sm"
        font-weight="strong"
        >{{redirectContentHeading}}</prism-ui-heading
        >
        <prism-ui-copy
          slot="modal-body"
          key-id="redirect-modal"
          >
          {{redirectContentBody}}
        </prism-ui-copy>
        <div slot="modal-footer">
          <div class="modalButtonStyling">
            <prism-ui-button class="leftPadding"
              button-width="full"
              key-id="cancel-redirect-button"
              size="md"
              variant="secondary"
              type="button"
              is-icon-right-aligned="false"
              (click)="onCancelRedirectModal('prism-ui-modal-redirect-modal')"
            >Try a Different Policy Number</prism-ui-button>
            <prism-ui-button class="leftPaddingSmall"
              button-width="full"
              key-id="continue-button"
              size="md"
              variant="primary"
              type="button"
              is-icon-right-aligned="false"
              (click)="redirect()"
            >Continue</prism-ui-button>
          </div>
        </div>
      </prism-ui-modal>